module.exports = __webpack_public_path__ + "static/media/Song_You.8ad3a516.jpg";